/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubmitSzafirSignedP1Dto
 */
export interface SubmitSzafirSignedP1Dto {
    /**
     * Base64-encoded Szafir-signed P1 XML document
     * @type {string}
     * @memberof SubmitSzafirSignedP1Dto
     */
    signedXmlBase64: string;
}

/**
 * Check if a given object implements the SubmitSzafirSignedP1Dto interface.
 */
export function instanceOfSubmitSzafirSignedP1Dto(value: object): value is SubmitSzafirSignedP1Dto {
    if (!('signedXmlBase64' in value) || value['signedXmlBase64'] === undefined) return false;
    return true;
}

export function SubmitSzafirSignedP1DtoFromJSON(json: any): SubmitSzafirSignedP1Dto {
    return SubmitSzafirSignedP1DtoFromJSONTyped(json, false);
}

export function SubmitSzafirSignedP1DtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubmitSzafirSignedP1Dto {
    if (json == null) {
        return json;
    }
    return {
        
        'signedXmlBase64': json['signedXmlBase64'],
    };
}

export function SubmitSzafirSignedP1DtoToJSON(value?: SubmitSzafirSignedP1Dto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'signedXmlBase64': value['signedXmlBase64'],
    };
}

